import React, { useState, useEffect } from "react";
import {
	ToggleButton,
	CircularProgress,
	Tooltip,
	Box,
	alpha,
} from "@mui/material";
import {
	CalendarMonth as CalendarMonthIcon,
	List as ListIcon,
} from "@mui/icons-material";

export default function CalendarToggle({ calendarmode, setCalendarmode }) {
	let [submitting, setSubmitting] = useState(false);
  let color = "rgba(0, 0, 0, 0.87)";

	const toggleView = async () => {
		try {
      let viewmode = calendarmode;
      setSubmitting(true);
			setCalendarmode(!viewmode);
			setSubmitting(false);
		} catch (e) {
			setSubmitting(false);
		}
	};

	return (
		<Box
			sx={(theme) => ({
				position: "relative",
				display: "inline-block",
        fontSize: "18px",
				marginLeft: theme.spacing(2),
				"& svg": {
					color: color,
				},
			})}
		>
			<Tooltip title={calendarmode ? "Events Calendar" : "Events List"}>
				<ToggleButton
					value="quilt"
					selected={calendarmode}
					onChange={() => {
						toggleView();
					}}
					style={{maxWidth: "30px", maxHeight: "30px", minWidth: "12px", minHeight: "12px", borderColor: alpha(color, 0.25), borderRadius: "50%", fontSize: "18px" }}
				>
					{submitting ? (
						<CircularProgress size={13} />
					) : calendarmode ? (
						<CalendarMonthIcon size={19} />
					) : (
						<ListIcon size={19} />
					)}
				</ToggleButton>
			</Tooltip>
		</Box>
	);
}
